import { Typography } from 'antd';
import type { TextProps } from 'antd/es/typography/Text';
import React from 'react';
import styled from 'styled-components';

const TitleWrapper = styled.div`
  color: ${props => props.theme.colorBgContainer};
  background-color: ${props => props.theme.colorPrimary};
  border-radius: ${props => props.theme.borderRadius}px
    ${props => props.theme.borderRadius}px 0 0;
  padding: 6px 12px;
  .ant-typography {
    color: inherit;
    font-size: 18px;
  }
`;

const CardCoverDocumentIconWrapper = styled.span`
  font-size: 32px;
  vertical-align: middle;
  line-height: 1em;
  margin-right: 6px;
`;

export interface CardCoverDocumentProps extends TextProps {
  icon: React.ReactNode;
  text: React.ReactNode;
}

export function CardCoverDocument(props: CardCoverDocumentProps) {
  const { icon, text, ...otherProps } = props;

  return (
    <TitleWrapper>
      <Typography.Text strong ellipsis {...otherProps}>
        <CardCoverDocumentIconWrapper>{icon}</CardCoverDocumentIconWrapper>
        {text}
      </Typography.Text>
    </TitleWrapper>
  );
}
